import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';

export interface LineChartData {
  name: string;
  series: Array<{
    name: string;
    formattedName?: string;
    initialDate: string;
    finalDate: string;
    totalCount: number;
    value: number;
  }>;
}

@Component({
  selector: 'line-chart',
  templateUrl: './line.component.html',
  styleUrls: ['./line.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class LineChartComponent {

  @Input() results: LineChartData[] = [];
  @Input() title: string;
  @Input() isLoading: true;
  @Input() xAxis = true;
  @Input() yAxis = true;
  @Input() autoScale = true;
  @Input() yScaleMax: number;
  @Input() yScaleMin: number;
  @Input() yAxisTickFormatting: string;
  @Input() isDateFormat = false;
  @Input() view: number[];
  @Input() scheme = {
    domain: [
      '#0054ff', '#ff3365', '#f9bb42', '#00194a', '#b0bacf', '#12b886', '#58595b']
  };
  @Output() select = new EventEmitter<any>();

  constructor(private fuseTranslationLoaderService: FuseTranslationLoaderService){
    this.fuseTranslationLoaderService.loadJsonTranslations({ english, portuguese, spanish });
  }
}
